import React, { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  useMediaQuery,
  useTheme,
  FormControl,
  Select,
  Box,
  OutlinedInput,
  Chip,
  MenuItem,
  FormLabel,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  RadioGroup,
  Paper,
  Radio,
  TableHead,
  TableBody,
  FormHelperText,
} from "@mui/material";
import {
  Loading,
  CustomRadioGroupLabel,
  CustomDialogTitle,
} from "../../components";
import { useMenteeContext } from "../../context/MenteeContext";
import {
  questionType,
  radioGroupMenuProps,
  allowedChars,
  specialChars,
  getStyles,
} from "../../constants/constants";
import {
  getActionItemsForMentoring,
  getMentoringActionItem,
  getRemarkAnswer,
  saveFeedback,
  updateFeedback,
  updateMeetingSchedulerStatus,
} from "../../utils/services";
import { useUserContext } from "../../context/UserContext";
import { enqueueSnackbar } from "notistack";
import { currentQuater } from "../../utils/validation";

function ActionItem({ open, setOpen }) {
  const [loading, setLoading] = useState(false);

  // values will be stored when selected from dropdown
  const [actionItemsList, setActionItemsList] = useState([]);
  const [recommendationList, setRecommendationList] = useState([]);

  // dropdown menu items array
  const [actionItemMenu, setActionItemMenu] = useState([]);
  const [recommendationMenu, setRecommendationMenu] = useState([]);

  // remarks data
  const [remark, setRemark] = useState({ value: "", disabled: false });
  const [remarkData, setRemarkData] = useState({});

  const [previousQuarterActionItems, setPreviousQuarterActionItems] = useState(
    []
  );

  const [state, setState] = useState({});
  const { user } = useUserContext();
  const { mentee, scheduleList, getMenteeSchedules, clearMenteeData } =
    useMenteeContext();
  const quarter = currentQuater();

  const theme = useTheme();
  const isMob = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClose = () => {
    setActionItemMenu([]);
    setRecommendationMenu([]);
    setActionItemsList([]);
    setRecommendationList([]);
    setOpen(false);
  };

  const handleSave = async () => {
    let remarkResponse;
    let response;

    if (mentee.scheduleType == "Observation") {
      if (actionItemsList.length > 3 || actionItemsList.length == 0) {
        enqueueSnackbar("Please select minimum 1 and maximum 3 action items.", {
          variant: "error",
        });
        return;
      }

      setLoading(true);
      const allActionItems = [
        ...actionItemMenu.filter((action) =>
          actionItemsList.includes(action.question)
        ),
        ...recommendationMenu.filter((action) =>
          recommendationList.includes(action.question)
        ),
      ];

      const data = allActionItems.map((action) => ({
        menteeId: mentee.id,
        questionId: action.questionId,
        answer: "Not_Completed",
        feedbackFor: action.questionFor,
        quaterName: quarter,
        feedbackType: action.questionType,
        createdBy: user.id,
        updatedBy: user.id,
      }));

      response = await saveFeedback(user.token, data);
    } else if (mentee.scheduleType == "Mentoring") {
      let dummy = {};
      previousQuarterActionItems.forEach((action) => {
        dummy[action.questionId] = action.answer;
      });

      if (JSON.stringify(dummy) !== JSON.stringify(state)) {
        setLoading(true);

        const data = previousQuarterActionItems.map((action) => {
          delete action.question;
          action.answer = state[action.questionId];
          action.updatedBy = user.id;
          return action;
        });

        response = await updateFeedback(user.token, data);
      }
      if (!remark.disabled && remark.value.length >= 100) {
        setLoading(true);

        const data = {
          menteeId: mentee.id,
          questionId: remarkData.questionId,
          answer: remark.value,
          feedbackFor: remarkData.questionFor,
          quaterName: quarter,
          feedbackType: remarkData.questionType,
          createdBy: user.id,
          updatedBy: user.id,
        };

        remarkResponse = await saveFeedback(user.token, [data]);
      }
    } else {
      console.log("something went wrong. Please try again later.");
    }

    if (
      response?.status == 200 ||
      response?.status == 201 ||
      remarkResponse?.status == 200 ||
      remarkResponse?.status == 201
    ) {
      let updateData = scheduleList.filter(
        (schedule) => schedule.menteeId == mentee.id
      )[0];
      updateData.updatedBy = user.id;

      let actionItemMsg = `Action items ${
        mentee.scheduleType == "Observation" ? "save" : "updated"
      } successfully for ${mentee.name}`;

      let remarkMsg = `Remark save successfully for ${mentee.name}.`;

      if (
        mentee.scheduleType == "Observation" ||
        (mentee.scheduleType == "Mentoring" &&
          Object.values(state).every((val) => val == "Completed") &&
          remark.value.length >= 100)
      ) {
        updateData.sessionStatus = "Completed";
      }

      if (updateData.sessionStatus != "Completed") {
        if (response) {
          enqueueSnackbar(actionItemMsg, {
            variant: "success",
          });
        }

        if (remarkResponse) {
          enqueueSnackbar(remarkMsg, {
            variant: "success",
          });
        }

        setLoading(false);
        clearMenteeData();
        setOpen(false);
        return;
      }

      const res = await updateMeetingSchedulerStatus(
        user.token,
        updateData.id,
        updateData.sessionStatus
      );

      if (res.status == 200 || res.status == 201) {
        await getMenteeSchedules();
        if (response) {
          enqueueSnackbar(actionItemMsg, {
            variant: "success",
          });
        }

        if (remarkResponse) {
          enqueueSnackbar(remarkMsg, {
            variant: "success",
          });
        }

        setLoading(false);
        setOpen(false);
        clearMenteeData();
      } else {
        enqueueSnackbar("Fail to update status. Please try again later.", {
          variant: "error",
        });
        setLoading(false);
      }
    } else {
      enqueueSnackbar(
        `Fail to ${
          mentee.scheduleType == "Observation" ? "save" : "update"
        } action items. Please try again later.`,
        {
          variant: "error",
        }
      );
      setLoading(false);
    }
  };

  const handleActionItemChange = (event) => {
    const {
      target: { value },
    } = event;

    // if we already have selected 3 action items and user is trying to add 4 item the don't allow
    if (actionItemsList.length == 3) {
      // On autofill we get a stringified value.
      if (typeof value === "string" && value.split(",").length > 3) {
        return;
      } else if (value.length > 3) {
        return;
      }
    }

    setActionItemsList(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleRecommendationChange = (event) => {
    const {
      target: { value },
    } = event;

    setRecommendationList(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleActionItemStatusChange = (e) => {
    const { name, value } = e.target;
    setState((oldState) => ({
      ...oldState,
      [name]: value,
    }));
  };

  // get the dropdown data (menu items) from the backend
  const getMentoringMenuItemList = async () => {
    // if we have not open the action items page then don't fetch the action items
    if (!open) return;

    // if we don't have mentee data then don't fetch the action items
    if (!mentee.id) return;

    // if schdule type is Mentoring and the action items popup is open then only fetch action items for selected mentee
    const response = await getMentoringActionItem(user.token, mentee.programId);
    if (response.status == 200) {
      setRemarkData(
        response.data.filter((q) => q.questionType == questionType.remarks)[0]
      );
      setActionItemMenu(
        response.data
          .filter((q) => q.questionType == questionType.actionItems)
          .sort((a, b) =>
            a.question > b.question ? 1 : a.question < b.question ? -1 : 0
          )
      );
      setRecommendationMenu(
        response.data
          .filter((q) => q.questionType == questionType.otherActions)
          .sort((a, b) =>
            a.question > b.question ? 1 : a.question < b.question ? -1 : 0
          )
      );
    }
  };

  const getActionItems = async () => {
    // if we have not open the action items page then don't fetch the action items
    if (!open) return;

    // if we don't have mentee data then don't fetch the action items
    if (!mentee.id) return;

    // if schedule type is Observation then don't fetch the action items
    if (mentee.scheduleType == "Observation") return;

    // if schdule type is Mentoring and the action items popup is open then only fetch action items for selected mentee
    if (!actionItemMenu.length && !remarkData.questionId) return;

    setLoading(true);
    setActionItemsList([]);
    setRecommendationList([]);
    setRemark({ value: "", disabled: false });
    setState({});
    setPreviousQuarterActionItems([]);

    let msg = "";
    let variant = "";
    const response = await getActionItemsForMentoring(user.token, mentee.id);
    const remarkResponse = await getRemarkAnswer(
      user.token,
      mentee.id,
      remarkData.questionId
    );

    if (remarkResponse.status == 200 && remarkResponse.data.length > 0) {
      setRemark({ value: remarkResponse.data[0].answer, disabled: true });
    }
    if (response.status == 200) {
      // filter answers where feedbacktype == "ACTION_ITEMS"
      const actionItems = response.data
        .filter((action) => action.feedbackType == questionType.actionItems)
        .map((action) => {
          const questionData = actionItemMenu.filter(
            (a) => a.questionId == action.questionId
          )[0];
          action.question = questionData.question;
          return action;
        });
      setPreviousQuarterActionItems(actionItems);

      // get the question id and answer and save in state variable
      let dummy = {};
      actionItems.forEach((action) => {
        dummy[action.questionId] = action.answer;
      });
      setState(dummy);

      msg = `${actionItems.length} action items are assigned to ${mentee.name}`;
      variant = "success";
    } else {
      msg = `Could not fetch action items assigned to ${mentee.name}. Please try again later.`;
      variant = "error";
    }
    enqueueSnackbar(msg, { variant });
    setLoading(false);
  };

  const handleSaveButtonDisable = () => {
    if (mentee.scheduleType == "Observation") {
      return actionItemsList.length == 0;
    } else if (mentee.scheduleType == "Mentoring") {
      let dummy = {};
      previousQuarterActionItems.forEach((action) => {
        dummy[action.questionId] = action.answer;
      });
      return previousQuarterActionItems.length == 0
        ? remark.value.length < 100 || specialChars.test(remark.value)
        : JSON.stringify(dummy) === JSON.stringify(state) ||
            remark.value.length < 100 ||
            specialChars.test(remark.value);
    } else {
      return true;
    }
  };

  useEffect(() => {
    getMentoringMenuItemList();
  }, [mentee, open]);

  useEffect(() => {
    if (open) {
      setActionItemMenu([]);
      setRecommendationMenu([]);
      setActionItemsList([]);
      setRecommendationList([]);
    }
  }, [open]);

  useEffect(() => {
    getActionItems();
  }, [actionItemMenu && remarkData]);

  return (
    <Dialog onClose={handleClose} open={open} fullScreen={isMob}>
      <CustomDialogTitle onClose={handleClose}>
        Action items For {mentee.name} - {mentee.programName}
      </CustomDialogTitle>

      <DialogContent dividers>
        {mentee.scheduleType == "Mentoring" ? (
          <>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Action</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {previousQuarterActionItems.map((action) => {
                    return (
                      <TableRow
                        key={action.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {action.question}
                        </TableCell>
                        <TableCell>
                          <FormControl margin="none">
                            <RadioGroup
                              key={action.questionId}
                              name={action.questionId.toString()}
                              value={state[action.questionId]}
                              onChange={handleActionItemStatusChange}
                            >
                              <CustomRadioGroupLabel
                                value="Completed"
                                control={<Radio size="small" />}
                                label="Completed"
                                disabled={action.answer == "Completed"}
                              />

                              <CustomRadioGroupLabel
                                value="Not_Completed"
                                control={<Radio size="small" />}
                                label="Not Completed"
                                disabled={action.answer == "Completed"}
                              />
                            </RadioGroup>
                          </FormControl>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            <FormControl required fullWidth size="small" margin="normal">
              <FormLabel>Remark</FormLabel>
              <OutlinedInput
                required
                multiline
                minRows={4}
                maxRows={10}
                disabled={remark.disabled}
                value={remark.value}
                onChange={(e) =>
                  setRemark((oldVal) => ({
                    ...oldVal,
                    value: e.target.value,
                  }))
                }
                inputProps={{ minLength: 100, maxLength: 500 }}
              />

              {remark.value.length < 100 && (
                <FormHelperText sx={{ color: "red", marginLeft: 0 }}>
                  Minimum 100 characters required.
                </FormHelperText>
              )}

              {specialChars.test(remark.value) && (
                <FormHelperText sx={{ color: "red", marginLeft: 0 }}>
                  Special Characters like {specialChars.toString().slice(1, -1)}{" "}
                  are not allowed. Special charaters like{" "}
                  {allowedChars.toString().slice(1, -1)} are allowed.
                </FormHelperText>
              )}
            </FormControl>
          </>
        ) : (
          <>
            <FormControl fullWidth size="small" required>
              <FormLabel>Training Recommendation</FormLabel>
              <Select
                multiple
                value={actionItemsList}
                onChange={handleActionItemChange}
                input={<OutlinedInput />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
                MenuProps={radioGroupMenuProps}
              >
                {actionItemMenu.map((action) => (
                  <MenuItem
                    key={action.id}
                    value={action.question}
                    style={getStyles(action.question, actionItemsList, theme)}
                  >
                    {action.question}
                  </MenuItem>
                ))}
              </Select>

              <FormHelperText
                sx={{ color: actionItemsList == 0 && "red", marginLeft: 0 }}
              >
                Minimum 1 and Maximum 3 actions to be selected
              </FormHelperText>
            </FormControl>

            <FormControl fullWidth size="small" margin="normal">
              <FormLabel>Other Recommendations</FormLabel>
              <Select
                size="small"
                multiple
                value={recommendationList}
                onChange={handleRecommendationChange}
                input={<OutlinedInput />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
                MenuProps={radioGroupMenuProps}
              >
                {recommendationMenu.map((action) => (
                  <MenuItem
                    key={action.id}
                    value={action.question}
                    style={getStyles(
                      action.question,
                      recommendationList,
                      theme
                    )}
                  >
                    {action.question}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose} color="error">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={handleSaveButtonDisable()}
          color="success"
        >
          Save changes
        </Button>
      </DialogActions>

      <Loading open={loading} />
    </Dialog>
  );
}

export default ActionItem;
